import axios from 'axios';
import { handleAPI } from '../tools/http';
  
let api = handleAPI({
  isLogin: '/api/weather/admin/isLogin',
  getLogin: '/api/weather/admin/login',
});

export default class User {
  constructor(ctx) {
    this.ctx = ctx;
    this.isLogin = false;
  }
  /**检测是否已经登录 */
  async getIsLogin() {
    return axios.get(api.isLogin, { withCredentials:true }).then(res => {
      const { data } = res;
      if (data.status === 1) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
    })
  }

  /**请求登录 */
  async getLogin(form) {
    return axios.post(api.getLogin, form, { withCredentials:true }).then(res => {
      const { data } = res;
      if (data.status === 1) {
        this.isLogin = true;
        this.ctx.$message.success('登录成功');
      } else {
        this.isLogin = false;
        this.ctx.$message.error(data.info);
      } 
    })
  }
}